// src/data/productos.ts

import { ProductoConDetalles, TipoVehiculo } from '../types';

// =========================================================================================
// === TIPOS Y ESTRUCTURAS DE FILTRO ===
// =========================================================================================

export const CARRO_MODELOS_POR_TIPO: Record<TipoVehiculo, string[]> = {
    'SUV': ['Bestune T77', 'Bestune T99', 'Bestune T55', 'Toyota Sequoia', 'Chevrolet Suburban', 'Land Rover Range Rover Sport HSE', 'Hyundai Venue', 'Toyota Fortuner VXR+'],
    'Sedán': ['Toyota Levin'],
    'Crossover': ['Toyota Corolla Cross', 'Toyota Veloz'],
    'Hatchback': [],
    'Coupe': [],     
    'Convertible': [], 
    'Pick-up': [],
    'Adventure': [], 'Doble Propósito': [], 'Street': [], 'Scooter': [] 
};

export const MOTO_MODELOS_POR_TIPO: Record<TipoVehiculo, string[]> = {
    'Adventure': [], 'Doble Propósito': ['Kawasaki KLR'], 'Street': [], 'Scooter': [],
    'SUV': [], 'Sedán': [], 'Hatchback': [], 'Coupe': [], 'Crossover': [], 'Convertible': [], 'Pick-up': []
};

// Agregamos las nuevas marcas
export const MARCAS_CARRO = ['Bestune', 'Toyota', 'Land Rover', 'Chevrolet', 'Hyundai'];
export const MARCAS_MOTO = ['Kawasaki']; 
export const MARCAS_COMBINADAS = [...MARCAS_CARRO, ...MARCAS_MOTO];

export const getModelosPorMarca = (marca: string): string[] => {
    switch (marca) {
        case 'Bestune': return ['T77', 'T99', 'T55'];
        case 'Toyota': return ['Levin', 'Corolla Cross', 'Sequoia', 'Veloz', 'Fortuner VXR+'];
        // Ajustado para coincidir con la lógica del filtro
        case 'Land Rover': return ['Range Rover Sport HSE'];
        case 'Chevrolet': return ['Suburban'];
        case 'Hyundai': return ['Venue'];
        case 'Kawasaki': return ['KLR'];
        default: return [];
    }
}

export const MOCK_TIPOS_VEHICULO: TipoVehiculo[] = [
    ...Object.keys(CARRO_MODELOS_POR_TIPO), 
    ...Object.keys(MOTO_MODELOS_POR_TIPO)
].filter(t => {
    const tipo = t as TipoVehiculo;
    return CARRO_MODELOS_POR_TIPO[tipo]?.length > 0 || MOTO_MODELOS_POR_TIPO[tipo]?.length > 0;
}) as TipoVehiculo[];

// =========================================================================================
// === DATA BASE ===
// =========================================================================================

const P_BESTUNE = '/Productos/Carros/Bestune/';
const P_TOYOTA = '/Productos/Carros/Toyota/';
const P_LANDROVER = '/Productos/Carros/Land Rover/';
const P_HYUNDAI = '/Productos/Carros/Hyundai/';
const P_CHEVROLET = '/Productos/Carros/Chevrolet/';
const P_KAWASAKI = '/Productos/Motos/Kawasaki/';

const BASE_PRODUCTOS: ProductoConDetalles[] = [
    // --- BESTUNE ---
    {
        id: 1, 
        nombre: 'Bestune T77 Pro', 
        precio: 26000, 
        tipo: 'carro', 
        condicion: 'usado',
        kilometraje: '36.000 km',
        color: 'Blanco',
        imgUrl: `${P_BESTUNE}T77/BestuneT77-1.webp`,
        descripcion: 'SUV deportivo en excelente estado. Diseño aerodinámico y tecnología Xiaomi AI Holographic. Oportunidad única por su bajo kilometraje.',
        imagenes: [
            `${P_BESTUNE}T77/BestuneT77-2.webp`,
            `${P_BESTUNE}T77/BestuneT77-3.webp`,
            `${P_BESTUNE}T77/BestuneT77-4.webp`,
            `${P_BESTUNE}T77/BestuneT77-5.webp`,
            `${P_BESTUNE}T77/BestuneT77-6.webp`,
            `${P_BESTUNE}T77/BestuneT77-8.webp`,
            `${P_BESTUNE}T77/BestuneT77-9.webp`,
            `${P_BESTUNE}T77/BestuneT77-10.webp`,
        ],
        tipoCarro: 'SUV',
        potencia: 169, 
        transmision: 'Automática DCT 7V', 
        motor: '1.5L Turbo',
        año: 2023,
        destacado: true,
    },
    {
        id: 2, 
        nombre: 'Bestune T99', 
        precio: 48000, 
        tipo: 'carro', 
        condicion: 'nuevo',
        color: 'Negra',
        imgUrl: `${P_BESTUNE}T99/BestuneT99-1.webp`,
        descripcion: 'El buque insignia de Bestune. Un SUV de lujo imponente, espacioso y con acabados premium. Unidad 0km lista para estrenar.',
        imagenes: [
            `${P_BESTUNE}T99/BestuneT99-2.webp`,
            `${P_BESTUNE}T99/BestuneT99-3.webp`,
            `${P_BESTUNE}T99/BestuneT99-4.webp`,
            `${P_BESTUNE}T99/BestuneT99-5.webp`,
            `${P_BESTUNE}T99/BestuneT99-6.webp`,
            `${P_BESTUNE}T99/BestuneT99-8.webp`,
            `${P_BESTUNE}T99/BestuneT99-9.webp`,
        ],
        tipoCarro: 'SUV',
        potencia: 224, 
        transmision: 'Automática 8V', 
        motor: '2.0L Turbo',
        año: 2024,
        destacado: true,
    },
    /*{
        id: 3, 
        nombre: 'Bestune T55', 
        precio: 29500, 
        tipo: 'carro', 
        condicion: 'usado',
        color: 'Negro', 
        imgUrl: `${P_BESTUNE}T55/BestuneT55-1.webp`,
        descripcion: 'SUV compacto dinámico y eficiente. Diseño "Sexy Diamond" con faros LED en forma de Y. Excelente relación precio-valor.',
        imagenes: [
            `${P_BESTUNE}T55/BestuneT55-2.webp`,
            `${P_BESTUNE}T55/BestuneT55-3.webp`,
            `${P_BESTUNE}T55/BestuneT55-4.webp`,
            `${P_BESTUNE}T55/BestuneT55-5.webp`,
            `${P_BESTUNE}T55/BestuneT55-6.webp`,
            `${P_BESTUNE}T55/BestuneT55-7.webp`,
            `${P_BESTUNE}T55/BestuneT55-8.webp`,
            `${P_BESTUNE}T55/BestuneT55-9.webp`,
            `${P_BESTUNE}T55/BestuneT55-10.webp`,
        ],
        tipoCarro: 'SUV',
        potencia: 169, 
        transmision: 'Automática DCT 7V',
        motor: '1.5L Turbo',
        año: 2023, 
        kilometraje: '18.817 km', 
    },*/


    // --- TOYOTA ---
    /*{ SIN STOCK
        id: 4, 
        nombre: 'Toyota Corolla Levin', 
        precio: 29900, 
        tipo: 'carro', 
        condicion: 'nuevo',
        color: 'Blanco',
        imgUrl: `${P_TOYOTA}Corolla Levin/Levin-1.webp`,
        descripcion: 'Elegancia y eficiencia. El Corolla Levin destaca por su diseño aerodinámico y confort interior. Ideal para la ciudad.',
        imagenes: [
            `${P_TOYOTA}Corolla Levin/Levin-2.webp`,
            `${P_TOYOTA}Corolla Levin/Levin-3.webp`,
            `${P_TOYOTA}Corolla Levin/Levin-4.webp`,
            `${P_TOYOTA}Corolla Levin/Levin-5.webp`,
            `${P_TOYOTA}Corolla Levin/Levin-6.webp`,
            `${P_TOYOTA}Corolla Levin/Levin-7.webp`,
            `${P_TOYOTA}Corolla Levin/Levin-8.webp`,
            `${P_TOYOTA}Corolla Levin/Levin-9.webp`,
            `${P_TOYOTA}Corolla Levin/Levin-10.webp`,
        ],
        tipoCarro: 'Sedán',
        potencia: 119, 
        transmision: 'Automática CVT',
        motor: '1.5L',
        año: 2025,
        kilometraje: '0 km',
        destacado: true,
    },*/
    /*{ SIN STOCK
        id: 5, 
        nombre: 'Toyota Corolla Cross Elite', 
        precio: 33400, 
        tipo: 'carro', 
        condicion: 'nuevo',
        color: 'Gris',
        imgUrl: `${P_TOYOTA}Corolla Cross/CrossGris-1.webp`,
        descripcion: 'El SUV más vendido del mundo. Versión Elite Edition con motor 2.0L Dynamic Force para mayor potencia y respuesta.',
        imagenes: [
            `${P_TOYOTA}Corolla Cross/CrossGris-2.webp`,
            `${P_TOYOTA}Corolla Cross/CrossGris-3.webp`,
            `${P_TOYOTA}Corolla Cross/CrossGris-4.webp`,
            `${P_TOYOTA}Corolla Cross/CrossGris-5.webp`,
            `${P_TOYOTA}Corolla Cross/CrossGris-6.webp`,
            `${P_TOYOTA}Corolla Cross/CrossGris-7.webp`,
            `${P_TOYOTA}Corolla Cross/CrossGris-8.webp`,
            `${P_TOYOTA}Corolla Cross/CrossGris-9.webp`,
        ],
        tipoCarro: 'Crossover',
        potencia: 169, 
        transmision: 'Automática Direct Shift-CVT',
        motor: '2.0L',
        año: 2025,
        kilometraje: '0 km',
    },*/
    /*{
        id: 6, 
        nombre: 'Toyota Corolla Cross Elite', 
        precio: 34900, 
        tipo: 'carro', 
        condicion: 'nuevo',
        color: 'Negro',
        imgUrl: `${P_TOYOTA}Corolla Cross/CrossNegro-1.webp`,
        descripcion: 'Versión Elite Edition en color Negro. Combinación perfecta de robustez urbana y estilo sofisticado.',
        imagenes: [
            `${P_TOYOTA}Corolla Cross/CrossNegro-2.webp`,
            `${P_TOYOTA}Corolla Cross/CrossNegro-3.webp`,
            `${P_TOYOTA}Corolla Cross/CrossNegro-4.webp`,
            `${P_TOYOTA}Corolla Cross/CrossNegro-5.webp`,
            `${P_TOYOTA}Corolla Cross/CrossNegro-6.webp`,
            `${P_TOYOTA}Corolla Cross/CrossNegro-7.webp`,
            `${P_TOYOTA}Corolla Cross/CrossNegro-8.webp`,
            `${P_TOYOTA}Corolla Cross/CrossNegro-9.webp`,      
            `${P_TOYOTA}Corolla Cross/CrossNegro-10.webp`,   
            `${P_TOYOTA}Corolla Cross/CrossNegro-11.webp`,          
            `${P_TOYOTA}Corolla Cross/CrossNegro-12.webp`,                            
        ],
        tipoCarro: 'Crossover',
        potencia: 169, 
        transmision: 'Automática Direct Shift-CVT',
        motor: '2.0L',
        año: 2025,
        kilometraje: '0 km',
    },*/
    {
        id: 7, 
        nombre: 'Toyota Sequoia Capstone', 
        precio: 150000, 
        tipo: 'carro', 
        condicion: 'usado',
        color: 'Blanco',
        imgUrl: `${P_TOYOTA}Sequoia/Sequoia-1.webp`,
        descripcion: 'El máximo lujo de Toyota. Versión Capstone Híbrida. Poderosa, inmensa y tecnológicamente avanzada. Una bestia del camino.',
        imagenes: [
            `${P_TOYOTA}Sequoia/Sequoia-2.webp`,
            `${P_TOYOTA}Sequoia/Sequoia-3.webp`,
            `${P_TOYOTA}Sequoia/Sequoia-4.webp`,
            `${P_TOYOTA}Sequoia/Sequoia-5.webp`,
            `${P_TOYOTA}Sequoia/Sequoia-6.webp`,
            `${P_TOYOTA}Sequoia/Sequoia-7.webp`,
            `${P_TOYOTA}Sequoia/Sequoia-8.webp`,
            `${P_TOYOTA}Sequoia/Sequoia-9.webp`,
            `${P_TOYOTA}Sequoia/Sequoia-10.webp`,
        ],
        tipoCarro: 'SUV',
        potencia: 437, 
        transmision: 'Automática 10V',
        motor: '3.4L V6 Biturbo Híbrido i-FORCE MAX',
        año: 2024,
        kilometraje: '27.396 km',
        destacado: true,
    },
    /*{
        id: 8, 
        nombre: 'Toyota Veloz', 
        precio: 34900, 
        tipo: 'carro', 
        condicion: 'nuevo',
        color: 'Negro',
        imgUrl: `${P_TOYOTA}Veloz/Veloz-1.webp`,
        descripcion: 'Versatilidad para 7 pasajeros. Diseño moderno y espacio inteligente para toda la familia.',
        imagenes: [
            `${P_TOYOTA}Veloz/Veloz-2.webp`,
            `${P_TOYOTA}Veloz/Veloz-3.webp`,
            `${P_TOYOTA}Veloz/Veloz-4.webp`,
            `${P_TOYOTA}Veloz/Veloz-5.webp`,
            `${P_TOYOTA}Veloz/Veloz-6.webp`,
            `${P_TOYOTA}Veloz/Veloz-7.webp`,
            `${P_TOYOTA}Veloz/Veloz-8.webp`,
            `${P_TOYOTA}Veloz/Veloz-9.webp`,        
        ],
        tipoCarro: 'Crossover',
        potencia: 105, 
        transmision: 'Automática CVT',
        motor: '1.5L',
        año: 2025,
        kilometraje: '0 km',
    },*/
    /*{
        id: 11, 
        nombre: 'Toyota Fortuner VXR+', 
        precio: 55000, 
        tipo: 'carro', 
        condicion: 'usado',
        color: 'Blanco',
        imgUrl: `${P_TOYOTA}Fortuner/FORTUNER-2018-BLINDADA-1.webp`,
        descripcion: 'Pura comodidad y fuerza en un solo vehiculo. Diseño moderno y espacio inteligente para toda la familia.',
        imagenes: [
            `${P_TOYOTA}Fortuner/FORTUNER-2018-BLINDADA-2.webp`,
            `${P_TOYOTA}Fortuner/FORTUNER-2018-BLINDADA-3.webp`,
            `${P_TOYOTA}Fortuner/FORTUNER-2018-BLINDADA-4.webp`,
            `${P_TOYOTA}Fortuner/FORTUNER-2018-BLINDADA-5.webp`,
            `${P_TOYOTA}Fortuner/FORTUNER-2018-BLINDADA-6.webp`,
            `${P_TOYOTA}Fortuner/FORTUNER-2018-BLINDADA-7.webp`,
            `${P_TOYOTA}Fortuner/FORTUNER-2018-BLINDADA-8.webp`,
            `${P_TOYOTA}Fortuner/FORTUNER-2018-BLINDADA-9.webp`,        
        ],
        tipoCarro: 'SUV',
        potencia: 201, 
        transmision: 'Automática',
        motor: '4.0L',
        año: 2018,
        kilometraje: '79.087 km',
    },*/

    // --- LAND ROVER ---
    /*{
        id: 9, 
        // CORREGIDO: Se agregó 'Land Rover' al nombre para que el buscador funcione
        nombre: 'Land Rover Range Rover Sport HSE', 
        precio: 88000, 
        tipo: 'carro', 
        condicion: 'usado',
        color: 'Blanco',
        imgUrl: `${P_LANDROVER}Range Rover Sport HSE/RRHSE-1.webp`,
        descripcion: 'Lujo británico y capacidad todoterreno. Versión HSE con motor V6 potente. Interior en cuero premium.',
        imagenes: [
            `${P_LANDROVER}Range Rover Sport HSE/RRHSE-2.webp`,
            `${P_LANDROVER}Range Rover Sport HSE/RRHSE-3.webp`,
            `${P_LANDROVER}Range Rover Sport HSE/RRHSE-4.webp`,
            `${P_LANDROVER}Range Rover Sport HSE/RRHSE-5.webp`,
            `${P_LANDROVER}Range Rover Sport HSE/RRHSE-6.webp`,
            `${P_LANDROVER}Range Rover Sport HSE/RRHSE-7.webp`,
            `${P_LANDROVER}Range Rover Sport HSE/RRHSE-8.webp`,
            `${P_LANDROVER}Range Rover Sport HSE/RRHSE-9.webp`,
        ],
        tipoCarro: 'SUV',
        potencia: 355, 
        transmision: 'Automática 8V',
        motor: '3.0L V6',
        año: 2020,
        kilometraje: '40.000 millas',
    },*/

    // --- HYUNDAI ---
    /*{
        id: 12,
        nombre: 'Hyundai Venue', 
        precio: 27000, 
        tipo: 'carro', 
        condicion: 'usado',
        color: 'Azul',
        imgUrl: `${P_HYUNDAI}Venue/Venue-1.webp`,
        descripcion: 'SUV compacto, ágil y robusto, diseñado para la aventura. Su estilo innovador y vibrante atrae miradas.',
        imagenes: [
            `${P_HYUNDAI}Venue/Venue-2.webp`,
            `${P_HYUNDAI}Venue/Venue-3.webp`,
            `${P_HYUNDAI}Venue/Venue-4.webp`,
            `${P_HYUNDAI}Venue/Venue-5.webp`,
            `${P_HYUNDAI}Venue/Venue-6.webp`,
            `${P_HYUNDAI}Venue/Venue-7.webp`,
            `${P_HYUNDAI}Venue/Venue-8.webp`,
        ],
        tipoCarro: 'SUV',
        potencia: 118, 
        transmision: 'Automática',
        motor: '1.6L',
        año: 2021,
        kilometraje: '12.713 km',
    },*/

    // --- CHEVROLET ---
    /*{
        id: 10, 
        nombre: 'Chevrolet Suburban LT', 
        precio: 47000, 
        tipo: 'carro', 
        condicion: 'usado',
        color: 'Negro',
        imgUrl: `${P_CHEVROLET}Suburban/Suburban-1.webp`,
        descripcion: 'La reina del espacio. 7 puestos reales con maletero gigante. Motor V8 legendario y tracción 4WD.',
        imagenes: [
            `${P_CHEVROLET}Suburban/Suburban-2.webp`,
            `${P_CHEVROLET}Suburban/Suburban-3.webp`,
            `${P_CHEVROLET}Suburban/Suburban-4.webp`,
            `${P_CHEVROLET}Suburban/Suburban-5.webp`,
            `${P_CHEVROLET}Suburban/Suburban-6.webp`,
            `${P_CHEVROLET}Suburban/Suburban-7.webp`,
            `${P_CHEVROLET}Suburban/Suburban-8.webp`,
        ],
        tipoCarro: 'SUV',
        potencia: 355, 
        transmision: 'Automática 6V', 
        motor: '5.3L V8 EcoTec3',
        año: 2020,
        kilometraje: '141.985 km',
    },*/

    // --- KAWASAKI ---
    {
        id: 13, 
        nombre: 'Kawasaki KLR', 
        precio: 12000, 
        tipo: 'moto', 
        condicion: 'usado',
        color: 'Gris',
        imgUrl: `${P_KAWASAKI}KLR/KLR-2022-1.jpeg`,
        descripcion: 'El ícono del dual-sport regresa con inyección electrónica y la robustez de siempre. Asfalto, tierra o grava: esta moto no pide permiso, pide kilómetros.',
        imagenes: [
            `${P_KAWASAKI}KLR/KLR-2022-2.jpeg`,
            `${P_KAWASAKI}KLR/KLR-2022-3.jpeg`,
            `${P_KAWASAKI}KLR/KLR-2022-4.jpeg`,
            `${P_KAWASAKI}KLR/KLR-2022-5.jpeg`,
            `${P_KAWASAKI}KLR/KLR-2022-6.jpeg`,
            `${P_KAWASAKI}KLR/KLR-2022-7.jpeg`,
            `${P_KAWASAKI}KLR/KLR-2022-8.jpeg`,
        ],
        tipoCarro: 'Doble Propósito',
        potencia: 40, 
        transmision: 'Manual', 
        motor: '650cc',
        año: 2022,
        kilometraje: '5.793 km',
    },
];

export const MOCK_PRODUCTOS: ProductoConDetalles[] = BASE_PRODUCTOS;

export const getFeaturedProducts = (): ProductoConDetalles[] => {
    return MOCK_PRODUCTOS.filter((p: ProductoConDetalles) => p.destacado === true).slice(0, 3);
};